import {
  createFileRoute,
  redirect,
  stripSearchParams,
} from '@tanstack/react-router'
import { fallback, zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

import { GuidelinesPage } from '@/pages/guidelines/Guidelines.page'
import { getIsGuidelinesEnabled } from '@/stores/features.store'

const DEFAULT_SEARCH = {
  name: null,
} as const

const SEARCH_SCHEMA = z.object({
  name: fallback(z.string().nullable(), DEFAULT_SEARCH.name).default(
    DEFAULT_SEARCH.name,
  ),
})

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/guidelines/',
)({
  component: GuidelinesPage,
  validateSearch: zodValidator(SEARCH_SCHEMA),
  beforeLoad: () => {
    if (!getIsGuidelinesEnabled()) {
      throw redirect({
        to: '/',
      })
    }
  },
  search: {
    middlewares: [stripSearchParams(DEFAULT_SEARCH)],
  },
})
